<div class="p-6 sm:p-8 max-w-7xl w-full mx-auto space-y-6">
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
    <div>
      <h1 class="text-2xl font-bold text-slate-800">Bienvenido al Panel de Control</h1>
      <p class="text-sm text-sakoo-dark mt-1">Aquí tienes un resumen del estado actual de tu negocio.</p>
    </div>
  </div>

  <!-- Stats Grid -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
    <!-- Stat Card 1 -->
    <div class="bg-white border border-sakoo-border p-6 rounded-2xl shadow-xs flex items-center justify-between">
      <div class="space-y-1">
        <p class="text-xs font-semibold uppercase tracking-wider text-sakoo-dark">Usuarios Activos</p>
        <p class="text-2xl font-bold text-slate-800">1,248</p>
      </div>
      <div class="h-12 w-12 rounded-xl bg-sakoo-green/10 flex items-center justify-center text-sakoo-green">
        <svg lucideUsers class="h-6 w-6"></svg>
      </div>
    </div>

    <!-- Stat Card 2 -->
    <div class="bg-white border border-sakoo-border p-6 rounded-2xl shadow-xs flex items-center justify-between">
      <div class="space-y-1">
        <p class="text-xs font-semibold uppercase tracking-wider text-sakoo-dark">Pedidos Nuevos</p>
        <p class="text-2xl font-bold text-slate-800">84</p>
      </div>
      <div class="h-12 w-12 rounded-xl bg-sakoo-green/10 flex items-center justify-center text-sakoo-green">
        <svg lucideShoppingBag class="h-6 w-6"></svg>
      </div>
    </div>

    <!-- Stat Card 3 -->
    <div class="bg-white border border-sakoo-border p-6 rounded-2xl shadow-xs flex items-center justify-between">
      <div class="space-y-1">
        <p class="text-xs font-semibold uppercase tracking-wider text-sakoo-dark">Crecimiento Mensual</p>
        <p class="text-2xl font-bold text-slate-800">+18.4%</p>
      </div>
      <div class="h-12 w-12 rounded-xl bg-sakoo-green/10 flex items-center justify-center text-sakoo-green">
        <svg lucideTrendingUp class="h-6 w-6"></svg>
      </div>
    </div>
  </div>

  <!-- Visual Panel / Empty State -->
  <div
    class="bg-white border border-sakoo-border rounded-2xl p-8 text-center shadow-xs flex flex-col items-center justify-center min-h-[300px]">
    <div
      class="h-16 w-16 bg-emerald-50 text-emerald-500 rounded-full flex items-center justify-center mb-4 border border-emerald-100">
      <svg lucideCheckCircle class="h-8 w-8"></svg>
    </div>
    <h3 class="text-lg font-bold text-slate-800">Todo en Orden</h3>
    <p class="text-sm text-sakoo-dark mt-2 max-w-sm">
      No se han detectado alertas en los servidores y todos los servicios de Sakoo están operando con normalidad.
    </p>
  </div>
</div>